import { render, staticRenderFns } from "./CustomerLayout.vue?vue&type=template&id=03d351d4&scoped=true&"
import script from "./CustomerLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLayout.vue?vue&type=style&index=0&id=03d351d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d351d4",
  null
  
)

component.options.__file = "CustomerLayout.vue"
export default component.exports